import api from '@shared/services/api';
import { ConnectionsResponse } from '../types/connection.types';

interface FetchUserConnectionsParams {
  page?: number;
  pageSize?: number;
  search?: string;
}

/**
 * Fetch user connections with pagination and search
 */
export const fetchUserConnections = async ({
  page = 1,
  pageSize = 10,
  search = "",
}: FetchUserConnectionsParams): Promise<ConnectionsResponse> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: pageSize.toString(),
    });

    if (search) {
      params.append("search", search);
    }

    const { data } = await api.get<ConnectionsResponse>(`/connections?${params}`);
    return data;
  } catch (error) {
    console.error("Error fetching connections:", error);
    throw error;
  }
};
